// src/lib/components/molecules/CustomDialog/CustomDialog.tsx
import React from 'react';
import { Dialog } from 'primereact/dialog';
import './CustomDialogAtom.scss';

interface CustomDialogAtomProps {
  /** Header content (string or any React node) */
  header: React.ReactNode;
  /** Whether the dialog is visible */
  visible: boolean;
  /** Called when the dialog requests to be hidden */
  onHide: () => void;
  /** Body content of the dialog */
  children: React.ReactNode;
  /** Optional footer content (e.g. button row) */
  footer?: React.ReactNode;
  /** Inline style overrides */
  style?: React.CSSProperties;
  /** Additional CSS class(es) */
  className?: string;
  /** Toggle display of the custom close‑icon */
  showCloseIcon?: boolean;
}

const CustomDialogAtom: React.FC<CustomDialogAtomProps> = ({
  header,
  visible,
  onHide,
  children,
  footer,
  style = { width: '90vw', maxWidth: '1400px', minHeight: '250px' },
  className = '',
  showCloseIcon = true,
}) => (
  <Dialog
    header={header}
    visible={visible}
    style={style}
    className={`custom-dialog ${className}`}
    onHide={onHide}
    footer={footer}
    dismissableMask
    modal
    icons={
      showCloseIcon && (
        <button
          className="custom-close-icon"
          onClick={onHide}
          aria-label="Close"
          type="button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 40 40"
            fill="none"
          >
            <g clipPath="url(#clip0_5169_27698)">
              <path
                d="M10.9237 29.0125C15.9537 34.0426 24.1088 34.0426 29.1388 29.0125C34.1687 23.9826 34.1688 15.8275 29.1388 10.7975C24.1088 5.76753 15.9537 5.76753 10.9237 10.7975C5.89369 15.8275 5.89376 23.9826 10.9237 29.0125Z"
                stroke="#377FC4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M24.387 24.2608L15.6755 15.5493M24.387 15.5493L15.6755 24.2608"
                stroke="#377FC4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_5169_27698">
                <rect
                  width="28"
                  height="28"
                  fill="white"
                  transform="translate(20 0.20105) rotate(45)"
                />
              </clipPath>
            </defs>
          </svg>
        </button>
      )
    }
  >
    {children}
  </Dialog>
);

export default CustomDialogAtom;
